(function () {
  function naturalCompare(a, b) {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  }

  // Parses a leading size like 5/64", 1-1/4", 1 1/4", 0.25", 6mm into inches so
  // fractions sort by value instead of by numerator. Returns null when not a size.
  var MIXED_FRACTION = /^\s*(?:(\d+)[\s-]+)?(\d+)\s*\/\s*(\d+)(.*)$/;
  var DECIMAL = /^\s*(\d*\.?\d+)(.*)$/;

  function parseSize(text) {
    var value;
    var rest;
    var match = text.match(MIXED_FRACTION);
    if (match && Number(match[3]) !== 0) {
      value = (match[1] ? Number(match[1]) : 0) + Number(match[2]) / Number(match[3]);
      rest = match[4];
    } else if ((match = text.match(DECIMAL))) {
      value = Number(match[1]);
      rest = match[2];
    } else {
      return null;
    }

    if (/^\s*mm\b/i.test(rest)) value = value / 25.4;
    else if (/^\s*cm\b/i.test(rest)) value = value / 2.54;
    return value;
  }

  // Whitespace is ignored so "TL160mm" and "TL 200mm" group under the same prefix.
  function normalize(text) {
    return text.replace(/\s+/g, '');
  }

  // Splits "TL 160mm" into prefix "TL" and size 160mm, comparing prefix first, then size.
  var PREFIX = /^[^\d.]*/;

  function compareVariantText(a, b) {
    var prefixA = a.match(PREFIX)[0];
    var prefixB = b.match(PREFIX)[0];
    var prefixOrder = naturalCompare(normalize(prefixA), normalize(prefixB));
    if (prefixOrder !== 0) return prefixOrder;

    var sizeA = parseSize(a.slice(prefixA.length));
    var sizeB = parseSize(b.slice(prefixB.length));
    if (sizeA !== null && sizeB !== null && sizeA !== sizeB) return sizeA - sizeB;
    if (sizeA !== null && sizeB === null) return -1;
    if (sizeA === null && sizeB !== null) return 1;
    return naturalCompare(normalize(a), normalize(b));
  }

  function sortVariantRobotList(list) {
    if (list.dataset.robotSorted === 'true') return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll(':scope > .VariantRobot--ProductItemText, :scope > .VariantRobot--ProductItem')
    );
    if (items.length < 2) return;

    items.sort(function (a, b) {
      var textA = (a.dataset.variantRobotProductItemText || a.textContent).trim();
      var textB = (b.dataset.variantRobotProductItemText || b.textContent).trim();
      return compareVariantText(textA, textB);
    });

    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      fragment.appendChild(item);
    });
    list.appendChild(fragment);
    list.dataset.robotSorted = 'true';
  }

  function sortVariantRobotBlocks(root) {
    (root || document).querySelectorAll('.VariantRobot--Products').forEach(sortVariantRobotList);
  }

  document.addEventListener('DOMContentLoaded', function () {
    sortVariantRobotBlocks();
  });

  // Variant Robot blocks can also arrive via quick-view/AJAX section renders.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.VariantRobot--Products')) {
          sortVariantRobotList(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.VariantRobot--Products').forEach(sortVariantRobotList);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
